import { render, staticRenderFns } from "./NpcModal.vue?vue&type=template&id=03f3c01a&scoped=true"
import script from "./NpcModal.vue?vue&type=script&lang=js"
export * from "./NpcModal.vue?vue&type=script&lang=js"
import style0 from "./NpcModal.vue?vue&type=style&index=0&id=03f3c01a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f3c01a",
  null
  
)

export default component.exports